import React, { useState } from "react";
import Header from "../Component/Header";
import Footer from "../Component/Footer";
import { API_BASE } from "../api/apiConfig";
import DestinationsDetaillist from "../Components/DestinationsDetaillist";
import MoDestinationsDetaillist from "../Components/MoDestinationsDetaillist";


const DestinationsDetail = () => {
    const [activeTab, setActiveTab] = useState("group"); // default A

  return (
    <>
      <Header />

<main className="flex-1">
  <div className="min-h-screen bg-slate-50">
    <div className="md:hidden">
      
    
    <MoDestinationsDetaillist />
      
     
      <section className="px-4 py-6 bg-white border-t">
        <h3 className="text-lg font-bold text-slate-900 mb-4">
          What Travelers Say About Spiti Valley
        </h3>
        <div className="space-y-4">
          <div className="rounded-lg bg-card text-card-foreground border shadow-sm">
            <div className="p-4">
              <div className="flex items-start gap-3">
                <div className="w-10 h-10 rounded-full overflow-hidden flex-shrink-0">
                  <img
                    alt="Priya S."
                    loading="lazy"
                    width={40}
                    height={40}
                    decoding="async"
                    data-nimg={1}
                    className="object-cover"
                    style={{ color: "transparent" }}
                    src="/assets/images/coastal-mountain-vista.png"
                  />
                </div>
                <div className="flex-1">
                  <div className="flex items-center justify-between">
                    <h4 className="font-semibold text-sm text-slate-900">
                      Priya S.
                    </h4>
                    <span className="text-xs text-slate-500">Dec 2025</span>
                  </div>
                  <div className="flex items-center gap-1 mt-1">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width={24}
                      height={24}
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth={2}
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      className="lucide lucide-star h-3 w-3 fill-yellow-400 text-yellow-400"
                    >
                      <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
                    </svg>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width={24}
                      height={24}
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth={2}
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      className="lucide lucide-star h-3 w-3 fill-yellow-400 text-yellow-400"
                    >
                      <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
                    </svg>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width={24}
                      height={24}
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth={2}
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      className="lucide lucide-star h-3 w-3 fill-yellow-400 text-yellow-400"
                    >
                      <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
                    </svg>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width={24}
                      height={24}
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth={2}
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      className="lucide lucide-star h-3 w-3 fill-yellow-400 text-yellow-400"
                    >
                      <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
                    </svg>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width={24}
                      height={24}
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth={2}
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      className="lucide lucide-star h-3 w-3 fill-yellow-400 text-yellow-400"
                    >
                      <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
                    </svg>
                    <span className="text-xs text-slate-500 ml-1">
                      (Group Trip)
                    </span>
                  </div>
                  <p className="text-sm text-slate-600 mt-2">
                    Amazing trip to Spiti Valley! The team made everything so
                    smooth and memorable.
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div className="rounded-lg bg-card text-card-foreground border shadow-sm">
            <div className="p-4">
              <div className="flex items-start gap-3">
                <div className="w-10 h-10 rounded-full overflow-hidden flex-shrink-0">
                  <img
                    alt="Rahul M."
                    loading="lazy"
                    width={40}
                    height={40}
                    decoding="async"
                    data-nimg={1}
                    className="object-cover"
                    style={{ color: "transparent" }}
                    src="/assets/images/solo-mountain-vista.png"
                  />
                </div>
                <div className="flex-1">
                  <div className="flex items-center justify-between">
                    <h4 className="font-semibold text-sm text-slate-900">
                      Rahul M.
                    </h4>
                    <span className="text-xs text-slate-500">Nov 2025</span>
                  </div>
                  <div className="flex items-center gap-1 mt-1">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width={24}
                      height={24}
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth={2}
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      className="lucide lucide-star h-3 w-3 fill-yellow-400 text-yellow-400"
                    >
                      <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
                    </svg>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width={24}
                      height={24}
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth={2}
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      className="lucide lucide-star h-3 w-3 fill-yellow-400 text-yellow-400"
                    >
                      <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
                    </svg>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width={24}
                      height={24}
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth={2}
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      className="lucide lucide-star h-3 w-3 fill-yellow-400 text-yellow-400"
                    >
                      <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
                    </svg>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width={24}
                      height={24}
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth={2}
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      className="lucide lucide-star h-3 w-3 fill-yellow-400 text-yellow-400"
                    >
                      <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
                    </svg>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width={24}
                      height={24}
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth={2}
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      className="lucide lucide-star h-3 w-3 fill-yellow-400 text-yellow-400"
                    >
                      <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
                    </svg>
                    <span className="text-xs text-slate-500 ml-1">
                      (Group Trip)
                    </span>
                  </div>
                  <p className="text-sm text-slate-600 mt-2">
                    Best travel experience ever! Met amazing people and created
                    lifelong memories.
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div className="rounded-lg bg-card text-card-foreground border shadow-sm">
            <div className="p-4">
              <div className="flex items-start gap-3">
                <div className="w-10 h-10 rounded-full overflow-hidden flex-shrink-0">
                  <img
                    alt="Ananya K."
                    loading="lazy"
                    width={40}
                    height={40}
                    decoding="async"
                    data-nimg={1}
                    className="object-cover"
                    style={{ color: "transparent" }}
                    src="/assets/images/manhattan-twilight.png"
                  />
                </div>
                <div className="flex-1">
                  <div className="flex items-center justify-between">
                    <h4 className="font-semibold text-sm text-slate-900">
                      Ananya K.
                    </h4>
                    <span className="text-xs text-slate-500">Oct 2025</span>
                  </div>
                  <div className="flex items-center gap-1 mt-1">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width={24}
                      height={24}
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth={2}
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      className="lucide lucide-star h-3 w-3 fill-yellow-400 text-yellow-400"
                    >
                      <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
                    </svg>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width={24}
                      height={24}
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth={2}
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      className="lucide lucide-star h-3 w-3 fill-yellow-400 text-yellow-400"
                    >
                      <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
                    </svg>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width={24}
                      height={24}
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth={2}
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      className="lucide lucide-star h-3 w-3 fill-yellow-400 text-yellow-400"
                    >
                      <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
                    </svg>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width={24}
                      height={24}
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth={2}
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      className="lucide lucide-star h-3 w-3 fill-yellow-400 text-yellow-400"
                    >
                      <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
                    </svg>
                    <span className="text-xs text-slate-500 ml-1">
                      (Customized Trip)
                    </span>
                  </div>
                  <p className="text-sm text-slate-600 mt-2">
                    Well organized trip with great accommodations. Highly
                    recommend!
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <button className="inline-flex items-center justify-center whitespace-nowrap rounded-md text-sm font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 border border-input hover:bg-accent hover:text-accent-foreground h-10 px-4 py-2 w-full mt-4 bg-transparent">
          View All Reviews
        </button>
      </section>
      <section className="px-4 py-6 bg-slate-50 border-t">
        <h3 className="text-lg font-bold text-slate-900 mb-4">
          Why Book With Us
        </h3>
        <div className="grid grid-cols-2 gap-3">
          <div className="bg-white rounded-xl p-3 shadow-sm">
            <div className="h-8 w-8 rounded-lg bg-teal-100 flex items-center justify-center mb-2">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width={24}
                height={24}
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth={2}
                strokeLinecap="round"
                strokeLinejoin="round"
                className="lucide lucide-shield h-4 w-4 text-teal-600"
              >
                <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10" />
              </svg>
            </div>
            <h4 className="font-semibold text-sm text-slate-900">
              Safe Travel
            </h4>
            <p className="text-xs text-slate-500 mt-0.5">
              Verified trips &amp; secure payments
            </p>
          </div>
          <div className="bg-white rounded-xl p-3 shadow-sm">
            <div className="h-8 w-8 rounded-lg bg-teal-100 flex items-center justify-center mb-2">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width={24}
                height={24}
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth={2}
                strokeLinecap="round"
                strokeLinejoin="round"
                className="lucide lucide-headphones h-4 w-4 text-teal-600"
              >
                <path d="M3 14h3a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-7a9 9 0 0 1 18 0v7a2 2 0 0 1-2 2h-1a2 2 0 0 1-2-2v-3a2 2 0 0 1 2-2h3" />
              </svg>
            </div>
            <h4 className="font-semibold text-sm text-slate-900">
              24/7 Support
            </h4>
            <p className="text-xs text-slate-500 mt-0.5">
              Always here to help you
            </p>
          </div>
          <div className="bg-white rounded-xl p-3 shadow-sm">
            <div className="h-8 w-8 rounded-lg bg-teal-100 flex items-center justify-center mb-2">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width={24}
                height={24}
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth={2}
                strokeLinecap="round"
                strokeLinejoin="round"
                className="lucide lucide-award h-4 w-4 text-teal-600"
              >
                <circle cx={12} cy={8} r={6} />
                <path d="M15.477 12.89 17 22l-5-3-5 3 1.523-9.11" />
              </svg>
            </div>
            <h4 className="font-semibold text-sm text-slate-900">Best Price</h4>
            <p className="text-xs text-slate-500 mt-0.5">
              Price match guarantee
            </p>
          </div>
          <div className="bg-white rounded-xl p-3 shadow-sm">
            <div className="h-8 w-8 rounded-lg bg-teal-100 flex items-center justify-center mb-2">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width={24}
                height={24}
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth={2}
                strokeLinecap="round"
                strokeLinejoin="round"
                className="lucide lucide-message-circle h-4 w-4 text-teal-600"
              >
                <path d="m3 21 1.9-5.7a8.5 8.5 0 1 1 3.8 3.8z" />
              </svg>
            </div>
            <h4 className="font-semibold text-sm text-slate-900">
              Pre-Trip Meetups
            </h4>
            <p className="text-xs text-slate-500 mt-0.5">
              Know your travel buddies
            </p>
          </div>
        </div>
      </section>
      <section className="px-4 py-6 bg-white border-t">
        <h3 className="text-lg font-bold text-slate-900 mb-4">
          Frequently Asked Questions
        </h3>
        <div className="space-y-3">
          <details className="group bg-slate-50 rounded-xl">
            <summary className="flex items-center justify-between p-4 cursor-pointer list-none">
              <span className="text-sm font-medium text-slate-900 pr-4">
                What is the best time to visit Spiti Valley?
              </span>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width={24}
                height={24}
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth={2}
                strokeLinecap="round"
                strokeLinejoin="round"
                className="lucide lucide-chevron-down h-4 w-4 text-slate-500 group-open:rotate-180 transition-transform flex-shrink-0"
              >
                <path d="m6 9 6 6 6-6" />
              </svg>
            </summary>
            <div className="px-4 pb-4">
              <p className="text-sm text-slate-600">
                The best time to visit Spiti Valley depends on your preferences.
                Most travelers prefer visiting during pleasant weather
                conditions for outdoor activities.
              </p>
            </div>
          </details>
          <details className="group bg-slate-50 rounded-xl">
            <summary className="flex items-center justify-between p-4 cursor-pointer list-none">
              <span className="text-sm font-medium text-slate-900 pr-4">
                How do I book a trip?
              </span>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width={24}
                height={24}
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth={2}
                strokeLinecap="round"
                strokeLinejoin="round"
                className="lucide lucide-chevron-down h-4 w-4 text-slate-500 group-open:rotate-180 transition-transform flex-shrink-0"
              >
                <path d="m6 9 6 6 6-6" />
              </svg>
            </summary>
            <div className="px-4 pb-4">
              <p className="text-sm text-slate-600">
                Simply select your preferred trip, choose your dates, and
                complete the booking. Our team will contact you within 24 hours
                to confirm details.
              </p>
            </div>
          </details>
          <details className="group bg-slate-50 rounded-xl">
            <summary className="flex items-center justify-between p-4 cursor-pointer list-none">
              <span className="text-sm font-medium text-slate-900 pr-4">
                Can I customize a group trip?
              </span>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width={24}
                height={24}
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth={2}
                strokeLinecap="round"
                strokeLinejoin="round"
                className="lucide lucide-chevron-down h-4 w-4 text-slate-500 group-open:rotate-180 transition-transform flex-shrink-0"
              >
                <path d="m6 9 6 6 6-6" />
              </svg>
            </summary>
            <div className="px-4 pb-4">
              <p className="text-sm text-slate-600">
                Yes! We offer flexible customization options. Contact us to
                discuss your specific requirements and preferences.
              </p>
            </div>
          </details>
          <details className="group bg-slate-50 rounded-xl">
            <summary className="flex items-center justify-between p-4 cursor-pointer list-none">
              <span className="text-sm font-medium text-slate-900 pr-4">
                What's included in the trip price?
              </span>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width={24}
                height={24}
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth={2}
                strokeLinecap="round"
                strokeLinejoin="round"
                className="lucide lucide-chevron-down h-4 w-4 text-slate-500 group-open:rotate-180 transition-transform flex-shrink-0"
              >
                <path d="m6 9 6 6 6-6" />
              </svg>
            </summary>
            <div className="px-4 pb-4">
              <p className="text-sm text-slate-600">
                Most trips include accommodation, meals as specified,
                transportation, activities, and a trip coordinator. Check
                individual trip pages for details.
              </p>
            </div>
          </details>
        </div>
      </section>
      <section className="px-4 py-6 bg-gradient-to-r from-teal-600 to-cyan-600 mb-12">
        <div className="text-center">
          <h3 className="text-white font-bold text-lg mb-2">
            Ready to Explore Spiti Valley?
          </h3>
          <p className="text-white/80 text-sm mb-4">
            Join our community and start your adventure today
          </p>
          <button className="inline-flex items-center justify-center whitespace-nowrap rounded-md text-sm font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 h-10 px-4 py-2 bg-white text-teal-600 hover:bg-slate-100">
            Plan Your Trip
          </button>
        </div>
      </section>
    </div>



      <DestinationsDetaillist />


    
  </div>
</main>


      <Footer />
    </>
  );
};

export default DestinationsDetail;
